import { Button, Form, Input, message, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { saveBudget } from "../controller/services/dashboard";
import { setLoading } from "../redux/slices/common_slice";

const SaveBudgetModal = ({
  open,
  onClose,
  showSuccessModal,
  setBudgetName,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.common?.loading || false);
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSave = async () => {
    try {
      await form.validateFields();
      saveBudgetHandler();
    } catch (err) {
      console.log(err);
    }
  };

  const getPayload = () => {
    setBudgetName(form.getFieldsValue().name);
    const payload = {
      currentMonth:
        dashboardData.expense.currentMonth || dashboardData.income.currentMonth, //MM-YYYY format
      title: form.getFieldsValue().name,
      totalIncome: dashboardData.totalIncome,
      totalExpense: dashboardData.totalExpense,
      remainBudget: dashboardData.remainBudget,
    };
    return payload;
  };

  const saveBudgetHandler = () => {
    const payload = getPayload();
    dispatch(setLoading(true));
    saveBudget(payload)
      .then((resp) => {
        if (resp.status) {
          handleClose();
          showSuccessModal();
        }
      })
      .catch((err) => message.error(err?.message))
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  return (
    <>
      <Modal
        width="415px"
        title={false}
        open={open}
        onOk={onClose}
        onCancel={handleClose}
        className="custom-common-modal"
        centered
        closeIcon={true}
        footer={false}
      >
        <div className="row modal-main-inner-row">
          <div className="col-12 text-center">
            <img
              src="/assets/images/icons/budget_icon.svg"
              className="img-fluid"
              alt=""
            />
            <h1 className="mb-3">{t("dashboard.saveBudget.title")}</h1>
            <p>{t("dashboard.saveBudget.desc")}</p>
            <div className="row mt-2 mb-0 ">
              <div className="col-12" style={{ textAlign: "left" }}>
                <Form
                  autoComplete="off"
                  className="common-input-form"
                  form={form}
                >
                  <Form.Item
                    className="mb-0 mt-2 "
                    name="name"
                    rules={[
                      { required: true, message: "Budget title is required!" },
                    ]}
                  >
                    <Input
                      placeholder={t("dashboard.saveBudget.placeholder")}
                    />
                  </Form.Item>
                </Form>
              </div>
            </div>
            <div className="row modal-footer-row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button onClick={handleClose}>
                  {t("dashboard.saveBudget.cancelBtn")}
                </Button>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button type="primary " onClick={handleSave} loading={loading}>
                  {t("dashboard.saveBudget.saveBtn")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SaveBudgetModal;
